import { Timestamp } from "firebase/firestore";

export const formatDate = (timestamp: Timestamp | undefined): string => {
  if (!timestamp) return "N/A";
  // For a more user-friendly date, you can use libraries like date-fns
  // This is a basic implementation:
  const date = new Date(timestamp.seconds * 1000);
  return date.toLocaleDateString('vi-VN', { // Example: Vietnamese locale
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

// Debounce utility function
export function debounce<F extends (...args: any[]) => any>(func: F, waitFor: number) {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  const debounced = (...args: Parameters<F>) => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => func(...args), waitFor);
  };

  debounced.cancel = () => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
}